import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { UseFormReturn } from "react-hook-form";
// Import the exported type
import type { InteractionFormData } from '../AddInteractionDialog';

interface InteractionFormFieldsProps {
  form: UseFormReturn<InteractionFormData>; // Using the imported type
}

export const InteractionFormFields = ({ form }: InteractionFormFieldsProps) => {
  const selectedType = form.watch("type");

  return (
    <>
      <FormField
        control={form.control}
        name="type"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Type</FormLabel>
            <Select onValueChange={field.onChange} defaultValue={field.value}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Select interaction type" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="note">Note</SelectItem>
                <SelectItem value="email">Email</SelectItem>
                <SelectItem value="call">Call</SelectItem>
                <SelectItem value="meeting">Meeting</SelectItem>
                <SelectItem value="offer_letter">Offer Letter</SelectItem>
                <SelectItem value="document">Document</SelectItem>
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="title"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Title</FormLabel>
            <FormControl>
              <Input placeholder="Enter title" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="content"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{selectedType === 'note' || selectedType === 'email' ? 'Content' : 'Notes'}</FormLabel>
            <FormControl>
              <Textarea 
                placeholder={selectedType === 'note' || selectedType === 'email' ? 'Enter content' : 'Add notes about this interaction'} 
                className="min-h-[100px]" 
                {...field} 
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {(selectedType === 'offer_letter' || selectedType === 'document') && (
        <FormField
          control={form.control}
          name="document"
          render={({ field: { value, onChange, ...fieldProps } }) => ( // Renamed field to fieldProps to avoid conflict
            <FormItem>
              <FormLabel>Upload File</FormLabel>
              <FormControl>
                <Input
                  type="file"
                  accept=".pdf,.doc,.docx"
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    // if (file) onChange(file); // onChange expects specific event or value
                    onChange(file || undefined);
                  }}
                  // {...fieldProps} // Spreading name, onBlur, ref. value is handled by input type="file"
                  name={fieldProps.name}
                  onBlur={fieldProps.onBlur}
                  ref={fieldProps.ref}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}
    </>
  );
};
